import AT from '../../actionTypes/'

const initialState = {}

export default function stagedRecord(state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case AT.SET_ORGANIZATION:
      return payload
    case AT.UPDATE_ORGANIZATION:
      return { ...state, ...payload }
    default: {
      return state
    }
  }
}
